
import { matchMedia } from 'window';

import ko from 'knockout';
import $ from 'jquery';

import Velocity from 'rgs-velocity-animate';

ko.bindingHandlers.mobileScroll = {
	init: function (element) {
		const $element = $(element);

		$element.on('click', () => {
			if (matchMedia('(max-width: 619px)').matches) {
				setTimeout(() => {
					Velocity.animate($element, 'scroll', { offset: -30 });
				}, 100);
			}
		});

		ko.utils.domNodeDisposal.addDisposeCallback(element, () => $element.off());
	},
};
